import { env } from '../..';
import { PaginationResponse } from '../model';

// Esporta il nome che avrà sul dispositivo
export const FILENAME_FAQ = 'guida-app-my-azimut.pdf';
export const FILENAME_COOKIE = 'cookie-policy.pdf';
export const FILENAME_INFORMATIVE = 'informativa-myazimut-dob.pdf';

export const USER_MANUAL_URL = `${env.storageBaseUrl}/documents/${FILENAME_FAQ}`;
export const COOKIE_POLICY_URL = `${env.storageBaseUrl}/documents/${FILENAME_COOKIE}`;
export const INFORMATIVE_URL = `${env.storageBaseUrl}/documents/${FILENAME_INFORMATIVE}`;

export const Currencies = {
  EURO: 'EUR',
};

export const defaultPagination: PaginationResponse = {
  count: 0,
  page: 1,
  perPage: 10,
};

export const AZIMUT_URL = 'https://www.azimut.it';
export const TMP_TOKEN_KEY = 'tmp_token';
export const BUNDLE_ID_KEY = 'bundle_id';
export const SELECTED_DOCUMENT_CLONE_KEY = 'selected_document_clone';
export const PERSIST_STORE_KEY = 'persist_store';
export const ADMIN_PERSIST_STORE_KEY = 'admin_persist_store';
export const MARKETPLACE_KEY = 'marketplace';
export const MAX_ATTEMPTS = 5;
export const MAX_ATTEMPTS_ADDITION = 13;
export const signatureAreaStatus = ['CREATED', 'EXPIRING', 'WIP'];
export const archivePracticeType = 'Archive';
export const THEMATIC_AREA_LIST = ['PF_AN', 'PF_KE', 'PF_OB', 'PF_FS', 'PF_FA'];
export const DEFAULT_MIFID_VALUE = [
  'Stato civile',
  'Nucleo familiare',
  'Titolo di studio',
  'Occupazione',
  'Scegli occupazione',
];
